<ng-container>

    <svg version="1.1" id="svg1" width="175" height="150" viewBox="0 0 230 230"
        xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg" (click)="run()">

        <defs id=" defs1">
            <linearGradient id="swatch10">
                <stop style="stop-color:#b10028;stop-opacity:1;" offset="0" id="stop10" />
            </linearGradient>
            <linearGradient id="swatch6">
                <stop style="stop-color:#b10028;stop-opacity:1;" offset="0" id="stop6" />
            </linearGradient>
            <linearGradient xlink:href="#swatch10" id="linearGradient10" x1="44.422173" y1="98.50293" x2="177.42131"
                y2="98.50293" gradientUnits="userSpaceOnUse" />
        </defs>
        <g id="g1" transform="translate(50 50)">

            <circle id="innerCircle" stroke="#b10028" fill="none" r="0" cx="50" cy="53" stroke-width="15">
                <animate id="innerCircle" xlink:href="#innerCircle" attributetype="XML" attributeName="r"
                    [attr.begin]="animations.innerCircleGrow.begin" [attr.dur]="animations.innerCircleGrow.duration"
                    from="10" to="100" fill="freeze">
                </animate>
                <animate id="innerCircle" xlink:href="#innerCircle" attributetype="CSS" attributeName="stroke-opacity"
                    [attr.begin]="animations.innerCircleFade.begin" [attr.dur]="animations.innerCircleFade.duration"
                    from="1" to="0" fill="freeze">
                </animate>
            </circle>

            <circle id="outerCircle" stroke="#b10028" fill="none" r="4" cx="50" cy="53" stroke-width="2">
                <animate id="outerCircle" xlink:href="#outerCircle" attributetype="XML" attributeName="r"
                    [attr.begin]="animations.outerCircleGrow.begin" [attr.dur]="animations.outerCircleGrow.duration"
                    from="20" to="100" fill="freeze">
                </animate>
                <animate id="outerCircle" xlink:href="#outerCircle" attributetype="CSS" attributeName="stroke-opacity"
                    from="1" to="0" fill="freeze" [attr.begin]="animations.outerCircleGrow.begin"
                    [attr.dur]="animations.outerCircleGrow.duration">
                </animate>
            </circle>
            -->
            <path
                style="fill:none;stroke-opacity:0;fill-opacity:1;stroke:url(#linearGradient10);stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke fill markers"
                d="M 105.04146,117.29464 48.652626,61.125929 c 0.03526,-9.390691 2.003923,-11.147777 11.075941,-11.42139 L 95.694521,85.345437 85.115673,74.543556 97.184715,62.147223 118.08668,81.499091 104.46711,68.554478 l 11.67767,-11.987244 20.27581,17.964603 -12.36703,-10.733241 11.82155,-11.733175 24.84592,23.327349 8.41515,10.583565 4.28515,10.622421 -0.0593,17.135944 -6.68614,16.4256 -10.83125,10.78013 -13.987,5.64079 -16.28,0.9973 -13.3828,-3.02732 -16.983293,-4.33728 -24.252082,-6.77715 -5.064432,-2.05205 5.357455,-8.76923 7.600784,-2.1237 12.950428,0.97253 11.7432,3.66611 4.94049,-4.14823 z"
                id="finger">
                <animate #fadeInAnimation id="FingerFadeIn" xlink:href="#finger" attributeType="CSS"
                    attributeName="stroke-opacity" [attr.begin]="animations.FingerFadeIn.begin"
                    [attr.dur]="animations.FingerFadeIn.duration" from="0" to="1" fill="freeze">
                </animate>
                <animateTransform #clickAnimation id="FingerSkewX" xlink:href="#finger" attributeType="XML"
                    attributeName="transform" type="skewX" [attr.begin]="animations.FingerSkew.begin" from="0" to="-3"
                    [attr.dur]="animations.FingerSkew.duration">
                </animateTransform>
                <animateTransform id="FingerSkewY" xlink:href="#finger" attributeType="XML" attributeName="transform"
                    type="skewY" from="0" to="-3" [attr.begin]="animations.FingerSkew.begin"
                    [attr.dur]="animations.FingerSkew.duration">
                </animateTransform>
                <animateTransform id="FingerRotate" xlink:href="#finger" attributeType="XML" attributeName="transform"
                    type="rotate" from="0" to="-3" [attr.begin]="animations.FingerSkew.begin"
                    [attr.dur]="animations.FingerSkew.duration">
                </animateTransform>
                <animateTransform id="FingerTranslate" xlink:href="#finger" attributeType="XML"
                    attributeName="transform" type="translate" from="0 0" to="-5 5"
                    [attr.begin]="animations.FingerSkew.begin" [attr.dur]="animations.FingerSkew.duration">
                </animateTransform>
                <animate id="FingerFadeOut" #fadeOutAnimation xlink:href="#finger" attributetype="CSS"
                    attributeName="stroke-opacity" [attr.begin]="animations.FingerFadeOut.begin"
                    [attr.dur]="animations.FingerFadeOut.duration" from="1" to="0" fill="freeze">
                </animate>
            </path>


        </g>
    </svg>
</ng-container>